import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=6a81cc0a&scoped=true&"
import script from "./MailList.vue?vue&type=script&lang=ts&"
export * from "./MailList.vue?vue&type=script&lang=ts&"
import style0 from "./MailList.vue?vue&type=style&index=0&id=6a81cc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81cc0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VDataTable,VTextField})
